import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ClassesHero() {
  return <section className="relative pt-24 pb-32 px-4 overflow-hidden" data-id="element-332">
      <div className="absolute inset-0 z-0" data-id="element-333">
        <img src="https://cdn.magicpatterns.com/uploads/5TrEmpSK7UVLrhiHggt39P/Programs.jpg" alt="Our Programs" className="w-full h-full object-cover object-center" data-id="element-334" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f3d]/90 via-[#0f1f3d]/85 to-[#0f1f3d]/90" data-id="element-335"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-336">
        <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-337">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight tracking-tight drop-shadow-2xl" data-id="element-338">
            Our Programs
          </h1>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-339"></div>
          <p className="text-lg sm:text-xl text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-340">
            We offer programs for all ages and all skill levels, starting with
            our Jr. students in our Basic Tae Kwon Do Class, to our Competition
            Team. Join us today and see why we are the best choice for you and
            your family. Our schedule is flexible and our classes are small so
            you get the attention you need to succeed. Come join the family!
          </p>
          <div className="pt-4" data-id="element-341">
            <Link to="/" className="inline-block px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30" data-id="element-342">
              Start Your $29 Trial
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}